export default __webpack_public_path__ + "static/media/Talent_FiveStarDiner.17643758.png";